import React from 'react'
import WakeUpCallListTable from './Components/WakeUpCallListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const WakeUpCallList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Wake Up Call List</HeadingOne>
          <AddItemBtn url="add-wake-up-call" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <WakeUpCallListTable />
      </div>
    </PageBody>
  );
};

export default WakeUpCallList;
